import React from 'react';
import { DATE_FORMAT_DISPLAY, daysOfWeekTimeWork } from '@constants';
import useFormField from '@hooks/useFormField';
import { Form } from 'antd';
const DayOfWeek = ({ value = [], onChange }) => {
    const handleToggle = (index) => {
        const newValues = [ ...value ];
        const oldValue = newValues[index] ?? 0;
        newValues[index] = (oldValue + 1) % 2;
        onChange(newValues);
    };
    return (
        <div className="day-of-week-container">
            {daysOfWeekTimeWork.map((el, index) => (
                <div
                    key={index}
                    className={[ 'dow-item', !!value[index] && 'dow-item-active' ].filter(Boolean).join(' ')}
                    onClick={() => handleToggle(index)}
                >
                    {el.label.charAt(0)}
                </div>
            ))}
        </div>
    );
};

const DayOfWeekToggle = ({ label, fieldName, format, placeholder, rules, required }) => {

    const dateFormat = format || DATE_FORMAT_DISPLAY;

    const { placeholder: _placeholder, rules: _rules } = useFormField({
        placeholder,
        rules,
        required,
    });
    return (
        <Form.Item label={label} name={fieldName} rules={_rules} shouldUpdate={false}>
            <DayOfWeek placeholder={_placeholder} dateFormat={dateFormat} />
        </Form.Item>
    );
};

export default DayOfWeekToggle;
